import { render, staticRenderFns } from "./AreaTrabalho.vue?vue&type=template&id=54cedf09"
import script from "./AreaTrabalho.vue?vue&type=script&lang=js"
export * from "./AreaTrabalho.vue?vue&type=script&lang=js"
import style0 from "./AreaTrabalho.vue?vue&type=style&index=0&id=54cedf09&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports